export function isEmpty(value) {
	if(isArray(value) === true) {
		if((value === null) || (value === undefined) || (value.length === 0)){
			return true;
		} else {
			return false;
		}
	} else {
		if((value === null) || (value === undefined) || (value === '')){
			return true;
		} else {
			return false;
		}
	}
}

// 判断此类型是否是Array类型
export function isObject (obj) {
	return Object.prototype.toString.call(obj) ==='[object Object]'
}

export function isNumber (obj) {
	if(Object.prototype.toString.call(obj) === '[object String]') {
		if(isNaN(Number(obj)) === true) {
			return false
		} else {
			return Object.prototype.toString.call(Number(obj)) ==='[object Number]'
		}
	} else {
		return Object.prototype.toString.call(obj) ==='[object Number]'
	}
}

// 判断此对象是否是Object类型
export function isArray (arr) {
	return Object.prototype.toString.call(arr) ==='[object Array]'
}

export function autoWrap (val) {
	if((val === null) || (val === undefined)) {
		return val;
	} else {
		return val.replace(/\n/g, '<br>');
	}
}

export function hasClass(ele, cls) {
	return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

export function addClass(ele, cls) {
	if (hasClass(ele, cls) === false) {
		//ele.className += ' ' + cls
		ele.classList.add(cls)
	}
}

export function removeClass(ele, cls) {
	if (hasClass(ele, cls) === true) {
		// const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
		// ele.className = ele.className.replace(reg, ' ')
		ele.classList.remove(cls)
	}
}

export function debounce(func, wait, immediate) {
	let timeout, args, context, timestamp, result

	const later = function() {
		// 据上一次触发时间间隔
		const last = +new Date() - timestamp

		// 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
		if (last < wait && last > 0) {
		timeout = setTimeout(later, wait - last)
		} else {
		timeout = null
		// 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
		if (!immediate) {
			result = func.apply(context, args)
			if (!timeout) context = args = null
		}
		}
	}

	return function(...args) {
		context = this
		timestamp = +new Date()
		const callNow = immediate && !timeout
		// 如果延时不存在，重新设定延时
		if (!timeout) timeout = setTimeout(later, wait)
		if (callNow) {
		result = func.apply(context, args)
		context = args = null
		}

		return result
	}
}

export function parseDateLineBreaks(time) {
	let reg = /^2\d{3}-(0[1-9]|1[0-2])$/g;
	if (reg.test(time) === true) {
		var date = new Date(time);
		var year = date.getFullYear() % 100;
		var month = (date.getMonth() + 1);
		return year + '年\n' + ((month >= 10) ? month : '0' + month) + '月';
	} else {
		return 'err';
	}
}

export function parseDateTooltips(time) {
	let reg = /^2\d{3}-(0[1-9]|1[0-2])$/g;
	if (reg.test(time) === true) {
		var date = new Date(time);
		var year = date.getFullYear();
		var month = (date.getMonth() + 1);
		return year + '-' + ((month >= 10) ? month : '0' + month);
	} else {
		return 'err'
	}
}

export function parseDateArray(time) {
	let reg = /^2\d{3}-(0[1-9]|1[0-2])$/g;
	if (reg.test(time) === true) {
		var dateArray = []
		var date = new Date(time);
		// var year = date.getFullYear() % 100;
		// var month = (date.getMonth() + 1);
		dateArray[0] = date.getFullYear();
		dateArray[1] =  date.getMonth() + 1;
		return dateArray;
	} else {
		return [];
	}
}

//通过文件下载url拿到对应的blob对象
export function ccxGetBlob(url) {
	return new Promise(resolve => {
		const xhr = new XMLHttpRequest()
		xhr.open('GET', url, true)
		xhr.responseType = 'blob'
		xhr.onload = () => {
		if (xhr.status === 200) {
			resolve(xhr.response)
		}
		}

		xhr.send()
	})
}

//下载文件 　　js模拟点击a标签进行下载
export function ccxSaveAs(blob, filename) {
	var link = document.createElement('a')
	link.href = window.URL.createObjectURL(blob)
	link.download = filename
	link.click()
}